/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {useAuth, getAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import UserSymbol from 'app/shared/Alfacom/Symbol/UserSymbol'
import {GetModuleColor, GetModuleIcon, GetModulePath, Module} from 'app/shared/Common/Enums'
import clsx from 'clsx'
import Iconize from 'app/shared/Alfacom/Icon/Iconize'
import ChangePassword from 'app/modules/auth/components/ChangePassword'
import {Modal, Row, Col, Button} from 'react-bootstrap'
import {toast} from 'react-toastify'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const [showChangePassword, setShowChangePassword] = useState(false)
  const [showChangePasswordWarning, setShowChangePasswordWarning] = useState(true)
  const [successPasswordChanged, setSuccessPasswordChanged] = useState(false)
  const state: any = useLocation().state

  useEffect(() =>  {
    if (state?.showPasswordExpiryReminder) {
      if (currentUser?.password?.isExpiredSoon) {
        toast(
          <>
            <div className='d-flex flex-column gap-1'>
              <div className='fw-bold'>Consider changing your password</div>
              <div>
                Your password will expire{' '}
                {currentUser.password.remainingDays == 0
                  ? 'today'
                  : currentUser.password.remainingDays == 1
                  ? 'tomorrow'
                  : `in ${currentUser.password.remainingDays} days`}
                . Please change your password before it expires to avoid any disruption while using the system.
              </div>
            </div>
          </>,
          {
            type: currentUser.password.remainingDays == 0 ? 'error' : 'warning',
            autoClose: false,
            onClose: () => {
              promptChangePassword();
            },
          }
        )
      }
    }
  }, [state])

  const handleLogoutClick = () => {
    logout()
  }

  const promptChangePassword = () => {
    const auth = getAuth()
    if (auth) {
      setShowChangePassword(true)
    }
  }

  const popUpChangePassword = () => {
    const handleCancelClick = () => {
      setShowChangePassword(false)
      setShowChangePasswordWarning(true)
    }

    return (
      <Modal
        show={true}
        onHide={() => {
          setShowChangePassword(false)
        }}
        centered
        backdrop='static'
      >
        <Modal.Header>
          <Modal.Title>
            {showChangePasswordWarning && 'Change Passwrod'}
            {successPasswordChanged && 'Password Updated Successfully'}
            {!showChangePasswordWarning && !successPasswordChanged && 'Change Password'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='min-h-150px'>
          <Row className='g-6'>
            {showChangePasswordWarning && (
              <p>
                Warning: Upon successful changing your password, you are required to login again using the new password. Please ensure all your works are saved
                before updating your password.
              </p>
            )}
            {successPasswordChanged && <p>Your password has been changed successfully. You must login again to use the system.</p>}
            {!showChangePasswordWarning && !successPasswordChanged && (
              <ChangePassword
                show={!showChangePasswordWarning && !successPasswordChanged}
                isModal={true}
                onCancel={handleCancelClick}
                onSuccessSave={() => {
                  setSuccessPasswordChanged(true)
                }}
              />
            )}
          </Row>
        </Modal.Body>
        {(showChangePasswordWarning || successPasswordChanged) && (
          <Modal.Footer className='d-flex flex-wrap gap-2 justify-content-end'>
            {showChangePasswordWarning && (
              <>
                <Button
                  variant={GetModuleColor(Module.Profile)}
                  onClick={() => {
                    setShowChangePasswordWarning(false)
                  }}
                >
                  Continue
                  <Iconize faIcon={'fas fa-arrow-right'} position='end' />
                </Button>
                <Button variant='light' onClick={handleCancelClick}>
                  <Iconize faIcon={`fas fa-times`} position='start' />
                  Cancel
                </Button>
              </>
            )}
            {successPasswordChanged && (
              <>
                <Button variant='light-danger' onClick={handleLogoutClick}>
                  <Iconize biIcon={`bi bi-escape`} position='start' />
                  Logout
                </Button>
              </>
            )}
          </Modal.Footer>
        )}
      </Modal>
    )
  }

  return (
    <>
      {showChangePassword && popUpChangePassword()}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <div className='menu-content d-flex align-items-center px-3'>
            <UserSymbol
              name={currentUser?.displayName!}
              description={currentUser?.email}
              alignment='left'
              position='top'
              shape='round'
              variant={GetModuleColor(Module.Profile)}
              truncate
            />
          </div>
        </div>

        <div className='separator my-2'></div>

        <div className='menu-item px-5 fs-base'>
          <a
            href={''}
            onClick={(e) => {
              e.preventDefault()
              promptChangePassword()
            }}
            className='menu-link px-5'
          >
            <Iconize faIcon={`fs-2 fas fa-key`} position='start' />
            <div className='d-flex flex-column'>
              <span>Change Password</span>
              {currentUser && currentUser.password?.isExpiredSoon && (
                <span className={`fw-normal fs-8 lh-1 text-muted`}>
                  <Iconize
                    faIcon={`fas fa-circle-exclamation me-1`}
                    color={currentUser?.password?.remainingDays == 0 ? 'danger' : 'warning'}
                    position='icon-only'
                  />
                  Password expires{' '}
                  {currentUser?.password?.remainingDays == 0
                    ? 'today'
                    : currentUser?.password?.remainingDays == 1
                    ? 'tomorrow'
                    : `in ${currentUser?.password?.remainingDays} days`}
                </span>
              )}
            </div>
          </a>
        </div>
      </div>
    </>
  )
}

export {HeaderUserMenu}
